import type { ReactNode } from "react";
import { Footer } from "@/components/footer/Footer";
import { NavBar } from "@/components/navbar/NavBar";
import { AppFrame } from "@/components/ui/AppFrame/AppFrame";
import { AppLayout } from "@/components/ui/AppLayout/AppLayout";
import type { TranslationPath } from "@/i18n/i18n.types";
import { t, tx } from "@/i18n/translate";
import type { ErrorReference } from "@/types/generated/openapi";
import { isDevelopment } from "@/utils/env";
import { ErrorMessage } from "./ErrorMessage";

interface FatalErrorPageProps {
  title?: TranslationPath;
  message?: string | ReactNode;
  reference?: ErrorReference;
  code?: number;
  error?: Error;
}

export function FatalErrorPage({ title = "error.title", message, code, reference, error }: FatalErrorPageProps) {
  return (
    <AppFrame>
      <AppLayout>
        {/* Show NavBar for / to avoid call to useElection outside ElectionProvider */}
        <NavBar location={{ pathname: "/" }} />
        <ErrorMessage title={t(title)} error={error}>
          {(code || reference) && (
            <p>
              {code && (
                <>
                  <strong>{code}</strong>&nbsp;
                </>
              )}
              {reference && <strong>{t(`error.api_error.${reference}`)}</strong>}
            </p>
          )}
          {message && <p className="mb-lg">{message}</p>}
          {isDevelopment && (
            <>
              <h6>{t("error.instruction.title")}</h6>
              <p>
                {tx("error.instruction.content", {
                  link: (content) => (
                    <a href="https://github.com/kiesraad/abacus" target="_blank" rel="noopener">
                      {content}
                    </a>
                  ),
                })}
              </p>
            </>
          )}
        </ErrorMessage>
        <Footer />
      </AppLayout>
    </AppFrame>
  );
}
